import { render } from "./FuneralKioskFormType4.vue?vue&type=template&id=15eb5aec&lang=true"
import script from "./FuneralKioskFormType4.vue?vue&type=script&lang=js"
export * from "./FuneralKioskFormType4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__